import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=5d6273f2&"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports